<div class="del text-center">
    <h3>Are you sure you want to delete this item?</h3>
    <div class="btns mt-3">
        <button class="btn btn-danger mr-2" (click)="delete()">Delete</button>
        <button class="btn btn-primary" (click)="cancel()">Cancel</button>
    </div>
</div>